var _defs, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebflowLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    zoomAndPan: "magnify",
    viewBox: "0 0 37.5 37.499999",
    height: 50,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "f6675a75db"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 37.007812 0 L 37.007812 37.007812 L 0 37.007812 Z M 0 0 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f6675a75db)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0 0 L 37.5 0 L 37.5 45 L 0 45 Z M 0 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0 0 L 37.5 0 L 37.5 37.5 L 0 37.5 Z M 0 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#545454",
    d: "M 0 0 L 37.5 0 L 37.5 37.5 L 0 37.5 Z M 0 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 18.675781 8.671875 C 13.148438 8.671875 8.671875 13.148438 8.671875 18.675781 C 8.671875 24.199219 13.148438 28.679688 18.675781 28.679688 C 24.199219 28.679688 28.679688 24.199219 28.679688 18.675781 C 28.679688 13.148438 24.199219 8.671875 18.675781 8.671875 Z M 22.332031 20.574219 C 21.878906 21.648438 21.039062 22.632812 19.488281 22.632812 C 19.488281 22.632812 18.832031 18.046875 18.820312 17.941406 C 18.78125 18.050781 17.851562 20.464844 17.851562 20.464844 C 17.414062 21.578125 16.578125 22.628906 15.027344 22.632812 L 13.8125 15.21875 C 14.820312 15.21875 16.066406 16.046875 16.15625 17.414062 C 16.15625 17.414062 16.3125 20.132812 16.320312 20.347656 C 16.40625 20.117188 17.460938 17.382812 17.460938 17.382812 C 17.875 16.265625 18.664062 15.214844 20.148438 15.214844 C 20.148438 15.214844 20.78125 20.105469 20.804688 20.335938 C 20.871094 20.105469 21.738281 17.382812 21.738281 17.382812 C 22.15625 16.265625 22.964844 15.214844 24.5 15.214844 Z M 22.332031 20.574219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebflowLogo);
export default __webpack_public_path__ + "static/media/WebflowLogo.6560c40e73631ea1750aa39a65d57c61.svg";
export { ForwardRef as ReactComponent };